module.exports = __webpack_public_path__ + "img/Unidad11-1.bb9c202a.png";